<main class="content">
  <section class="top-section">
    <span class="title">Tribus</span>
    <!-- Barra de búsqueda -->
    <!-- <article class="buttons">
      <div class="search-box">
        <button class="btn-search">
          <img src="assets\search-icon.svg" alt="search icon" />
        </button>
        <input type="text" class="input-search" placeholder="Buscar tribus.." />
      </div>
      <div class="dropdown-center">
        <button class="btn-filter-tribe" data-bs-toggle="dropdown">
          <img src="../../../assets/filter-tribe-icon.svg" alt="filter icon" />
          {{ option }}
          <img
            src="../../../assets/arrow-filter-tribe-icon.svg"
            alt="arrow filter icon"
          />
        </button>
        <ul class="dropdown-menu">
          <li>
            <a class="dropdown-item" (click)="onClick('Todas las tribus')"
              >Todas las tribus</a
            >
          </li>
          <li>
            <a class="dropdown-item" (click)="onClick('Activos')">Activos</a>
          </li>
          <li>
            <a class="dropdown-item" (click)="onClick('Cerrados')">Cerrados</a>
          </li>
          <li>
            <a class="dropdown-item" (click)="onClick('Seguidos')">Seguidos</a>
          </li>
          <li>
            <a class="dropdown-item" (click)="onClick('No seguidos')"
              >No seguidos</a
            >
          </li>
        </ul>
      </div>
    </article> -->
  </section>
  <section class="table-section">
    <app-table-tribes>
      <tr app-row-tribe *ngFor="let tribe of tribesList" [tribe]="tribe" class="all-rows"
        (onClickRow)="onClickRow($event)" (commentCreatedEvent)="commentCreatedEvent($event)">
        >
      </tr>
    </app-table-tribes>
  </section>
</main>
<!-- MODAL TRIBES COMMENTS -->
<app-modal-side-dialog #modalTribe [active]="isActiveModal" class="modal-tribe">
  <div class="btn-close-modal-tribe">
    <button (click)="closeModal()">Cerrar</button>
  </div>
  <div *ngIf="loading" class="spinner-border" style="width: 3rem; height: 3rem" role="status">
    <span class="visually-hidden">cargando...</span>
  </div>
  <div class="modal-tribe-content" *ngIf="!loading">
    <!-- HEAD COMMENT: USER HAS CREATED FORO WITH SUBJECT -->
    <h5 class="modal-title">{{ dataModal.attributes.title }}</h5>
    <div class="main-tribe">
      <div [innerHTML]="dataModal.attributes.body?.value || ''"></div>
      <div class="d-flex gap-4 pt-2">
        <small [style]="{ color: '#cbcbcb6e', display: 'flex', gap: '2px' }">
          <!-- <span>Creador: </span> -->
          <img *ngIf="dataModal.ownerProfile?.user_picture" [src]="
              dataModal.ownerProfile?.user_picture?.url ||
              '../../assets/images/user.png'
            " alt="user owner tribe" class="user-picture" width="20px" height="20px"
            [style]="{ 'border-radius': '50%' }" />
          <img *ngIf="!dataModal.ownerProfile?.user_picture" [src]="'../../assets/images/user.png'"
            alt="user owner tribe" class="user-picture" width="20px" height="20px"
            [style]="{ 'border-radius': '50%' }" />
          {{
          dataModal.ownerProfile?.field_name
          ? dataModal.ownerProfile?.field_name
          : "Usuario"
          }}
        </small>
        <small title="Número de comentarios" [style]="{ color: '#cbcbcb6e' }">
          {{ tribeSelected.attributes.comment_forum.comment_count || "0" }}
          <i class="bi bi-chat-left"></i></small>
      </div>
    </div>
    <app-input-comment-tribe (onPublishComment)="getNewInputComment($event)" [urlImageProfileLogued]="userImgLogued" />

    <!-- LIST COMMENTS -->
    <div class="comments-section">
      <ng-container>
        <ul>
          <li *ngFor="let item of dataModal.comments">
            <app-card-comment-tribe [fatherThread]="item.thread" [data]="item" />
          </li>
        </ul>
      </ng-container>
    </div>
  </div>
</app-modal-side-dialog>